import { Layout } from 'components'
import { ReportsDashboard as LegacyReportsDashboard } from '@legacy/common/components/apps/reports_dashboard'
import { CurrentUserContextProvider } from 'context'
import { useFeatureToggle } from 'hooks'
import { ArcReportsContent } from 'pages/ArcReports'

export function ReportsDashboard() {
  const isArc = useFeatureToggle('arc-mosaico-project') as boolean

  return (
    <CurrentUserContextProvider>
      <Layout>
        {isArc ? <ArcReportsContent /> : <LegacyReportsDashboard />}
      </Layout>
    </CurrentUserContextProvider>
  )
}